<script setup>
import {useUsersStore} from "@/stores"
import moment from "moment-timezone"
import {numberWithCommas} from "@/plugins/misc"

const props = defineProps({
  isDialogVisible: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits([
  'update:isDialogVisible',
  'confirm',
  'cancel'
])
const usersStore = useUsersStore()
let myUser = null;
({myUser} = storeToRefs(usersStore))



const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}
const onConfirmation = () => {
  emit('confirm', true)
  updateModelValue(false)
}
const onCancel = () => {
  emit('cancel', true)
  emit('update:isDialogVisible', false)
}
const onClose = () => {
  emit('close', true)
  emit('update:isDialogVisible', false)
}
const deleteAccount = async () => {
  myUser.value.markedForDeletion = true
  let success = await usersStore.updateMyUser()
}
const cancelDeleteAccount = async () => {
  myUser.value.markedForDeletion = false
  let success = await usersStore.updateMyUser()
}
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    max-width="500"
    :model-value="props.isDialogVisible"
    @update:model-value="updateModelValue"
  >
    <VCard class="text-center px-10 py-6">
      <template v-if="myUser.markedForDeletion">
        <div class="mt-8 text-lg font-weight-medium">
          We’re sorry to see you go. Your account will be removed & you’ll receive a confirmation email once the process is complete
        </div>
        <VCardActions
          class="align-center justify-center gap-2 mt-4"
        >
          <VBtn
            variant="elevated"
            color="primary"
            @click="onClose"
          >
            Ok
          </VBtn>
          <VBtn
            variant="elevated"
            color="secondary"
            @click="cancelDeleteAccount"
          >
            Cancel account deletion
          </VBtn>
        </VCardActions>
      </template>
      <template v-else>
        <div class="mt-6">
          <h6 class="text-lg font-weight-medium mb-2">
            Delete your account?
          </h6>
          <p>Once you delete your account, you can’t undo it. Please be sure. If you do, here is what will happen:</p>
          <p>- Your account will be deleted in 24 hours</p>
          <p>- You will no longer able to access any past reservations or favorites</p>
          <p>- Any/all credit card information you shared for bookings will be deleted from our database</p>
          <p>- Restaurants will still have some basic information about your visits that you submitted to get Preferred Reservations and/or events (if applicable)</p>
        </div>

        <VCardActions
          v-if="true"
          class="align-center justify-center gap-2 mt-4 "
        >
          <VBtn
            variant="elevated"
            color="error"
            @click="deleteAccount"
          >
            Delete my account
          </VBtn>

          <VBtn
            color="secondary"
            variant="tonal"
            @click="onCancel"
          >
            Cancel
          </VBtn>
        </VCardActions>
      </template>
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
